export default __webpack_public_path__ + "static/media/PLURcoin.6fdc2be8.png";